<template>
    <div class="Search">
        <div class="main">
            <h2>{{languageStrings['Was dürfen wir für dich finden?']}}</h2>
            <h3>{{languageStrings['SUCHBEGRIFF EINGEBEN']}}</h3>
            <div class="input-container">
                <input type="text" v-model="searchTerm" @keydown="checkKey($event)" :placeholder="languageStrings['suche']" style="text-transform: uppercase">
                <img class="icon" src="@/assets/searchicon.svg" alt="">
            </div>

            <div class="suggestions" v-if="suggestions.length > 0">
                <router-link v-for="shop in suggestions" v-bind:key="shop.id" :to="{ name: 'ShopDetails', params: { id: shop.id, backlink: backlink }}" >
                    <span :class="'h'+shop.house" class="block"></span>
                    <span v-html="shop.name"></span>
                </router-link>
            </div>
            <div class="empty-container" v-if="suggestions.length < 1 && searchTerm.length > 3">
                <h3>{{languageStrings.nothingFound}}</h3>
                <p><img src="@/assets/warningiconorange.svg">{{languageStrings.emptySearch1}}</p>
                <p><img src="@/assets/warningiconorange.svg">{{languageStrings.emptySearch2}}</p>
            </div>
            <SimpleKeyboard @onChange="onChange" :languageStrings="languageStrings"></SimpleKeyboard>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    import Advertising from "../../components/Advertising";
    import SimpleKeyboard from "../../components/Keyboard";

    export default {
        name: 'Search',
        components: {
            SimpleKeyboard,
            Advertising,
        },
        data(){
            return {
                searchTerm: '',
            }
        },
        props: ['store', 'languageStrings'],
        methods: {
            onChange: function(data){
                this.searchTerm = data;
            },
            checkKey(event){
                console.log(event.key)
                if (event.key == '&'){
                    event.preventDefault();
                    event.stopPropagation()
                    return false
                }
            }
        },
        computed: {
            suggestions: function () {
                if ( this.searchTerm.length > 1 ){
                    let foundShops = [];
                    let foundItems = [];
                    let v = this;
                    let s = v.searchTerm.toLowerCase().replace('&', '&#038;');
                    console.log(s);
                    this.store.shops.forEach(function (el) {

                        if (el.name.toLowerCase().indexOf(s) > -1 ) {
                            foundShops.push(el);
                        } else if ( el.keywords.find( x => x.toLowerCase().indexOf(v.searchTerm.toLowerCase()) > -1 ) ){
                            foundItems.push(el);
                        }
                    })

                    return foundShops.concat(foundItems).slice(0, 10);
                } else return []

            },
            message: function () {
                if ( this.searchTerm.length < 1 ){
                    return this.languageStrings['searchMoreLetters'];
                } else if ( this.suggestions.length == 0 ){
                    return this.languageStrings['noshops']
                } else return ''

            },
            backlink(){
                return '/search';
            },
        },
        created: function () {
            if (this.$route.params.searchterm){
                this.searchTerm = this.$route.params.searchterm
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/variables";

    .Search {
        padding-left: $advertisingPadding;
        @include portrait(){
            padding-left: 0;
        }
    }

    input {
        font-size: 20px;
        height: 60px;
        background: none;
        border-radius: 30px;
        border: 2px solid #BFBFBF;
        margin-bottom: 20px;
        width: 997px;
        padding-left: 20px;

      @include portrait(){
        width: 80%;
      }
    }

    .icon {
        position: relative;
        left: -40px;
        top: 1px;
    }

    .suggestions {
      height: 250px;
      overflow: hidden;
      @include portrait(){
        height: 560px;
      }

        a {
            display: block;
            font-size: 24px;
            color: $gray2;
            margin-bottom: 10px;
            font-weight: 700;
            margin-bottom: 30px;
            display: flex;
            align-items: center;

            .block {
                width: 20px;
                height: 20px;
                display: inline-block;
                background-color: red;
                border-radius: 3px;
                margin-right: 20px;
                position: relative;
                top: 1px;

                &.h1 {
                    background-color: $blue;
                }
                &.h3{
                    background-color: $green;
                }
                &.h5 {
                    background-color: $purple;
                }
                &.h7 {
                    background-color: $yellow;
                }
                &.h9 {
                    background-color: $rose;
                }

            }
        }
    }

    .empty-container {
        h3 {
            font-size: 24px;
            color: $gray2;
            margin-top: 50px;
        }

        p {
            font-size: 16px;
            font-weight: bold;
            img {
                position: relative;
                top: 5px;
                margin-right: 10px;
            }
        }
    }

</style>
